import { FixbotCTA } from '@ifixit/fixbot/fixbot-cta';
import initializeComponent from 'Shared/react-initialize';

function WikiFixbotCTACard({
   contentId,
   contentType,
}: {
   contentId: number;
   contentType: 'wiki' | 'device';
}) {
   const isDevice = contentType === 'device';
   return (
      // The credit that follows has an 80px top margin (author credit via
      // credit_author_team.less, translation credit via a scoped mt-20! in
      // translate_credit.phtml); the negative bottom margin nets that down
      // to ~24px so the CTA isn't separated from it by a big gap. The top
      // margin keeps the CTA from sitting flush against the content above.
      <div className="-mb-14 mt-6">
         <FixbotCTA
            // Device/topic pages are wiki records, so FixBot looks them up as
            // type=wiki. The Device vs Wiki split only drives copy + analytics.
            contentType="wiki"
            contentId={contentId}
            analyticsCategory={isDevice ? 'Device' : 'Wiki'}
            translationNamespace={isDevice ? 'FixbotCTADevice' : 'FixbotCTAWiki'}
         />
      </div>
   );
}

initializeComponent('WikiFixbotCTACard', WikiFixbotCTACard);
